import Text from 'components/Text/Text';
import React from 'react';
import ReportTypeField from './components/ReportTypeField';
import ScheduleTypesField from './components/ScheduleTypesField';
import EmailsField from './components/EmailsField';
import CopyEmailsField from './components/CopyEmailsField';
import { SendingReportAfterShiftClosingField } from './components/SendingReportAfterShiftClosingField';
import classNames from 'classnames';
import style from './ReportsTab.module.scss';

const ReportsTab: React.FC = () => {
	const emailsRowClasses = classNames(style.row, style.emailWrapper);

	return (
		<div className={style.container} data-test="ReportsTab">
			<div className={style.fieldsWrapper}>
				<Text
					translationNameSpace="form"
					translationKey="infoHeading"
					theme="secondary"
					size="l"
					weight="bold"
				/>
				<div className={style.row}>
					<ReportTypeField />
					<ScheduleTypesField />
				</div>
			</div>
			<div className={style.fieldsWrapper}>
				<Text
					translationNameSpace="form"
					translationKey="emailsHeading"
					theme="secondary"
					size="l"
					weight="bold"
				/>
				<div className={emailsRowClasses}>
					<EmailsField />
					<CopyEmailsField />
				</div>
			</div>
			<div className={style.fieldsWrapper}>
				<Text
					translationNameSpace="form"
					translationKey="sendingReportHeading"
					theme="secondary"
					size="l"
					weight="bold"
				/>
				<SendingReportAfterShiftClosingField />
			</div>
		</div>
	);
};

export default ReportsTab;
